<template>
  <section class="container">
    <div class="row">
      <div class="col text-center">
        <h1>Estamos em manutenção!</h1>
        <p>Volte mais tarde.</p>
      </div>
    </div>
  </section>
</template>

<script setup></script>

<style scoped>
.maintenance-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  background-color: #f8f9fa;
  color: #333;
}
</style>